import { defaultAxios, IParams } from './base';

export interface IFetchPromotionCheck extends IParams {
  custSeq: string;
  promotionSeq: string;
}

export const fetchPromotionCheck = (params: IFetchPromotionCheck) => {
  return defaultAxios().post(`/promotion/check`, params);
};
